module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMA/wD/AP83WBt9AAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAJElEQVR42mP8//8/AymAiYFEQHsNLKtXMwx1PwwHDYzDIC0BAKzNB3EpTyG4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_bp.png
// module id = 0KlI
// module chunks = 0